import { render, staticRenderFns } from "./OnboardingLiveness.vue?vue&type=template&id=7f75d54f&"
import script from "./OnboardingLiveness.vue?vue&type=script&lang=js&"
export * from "./OnboardingLiveness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports